import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const modulesFiles = require.context('./modules', true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

import setting from '@/setting'


export default new Vuex.Store({
  state: {
    adminCollapse: false,
    adminUser: { accessToken: '', expiredTime: '', userId: '', userOrganizationId: '', userType: '', userAccount: '', userName: '' },
    adminMenus: [],
    adminRoles: [],
    adminOrganizations: []
  },
  getters: {
    adminRouter(state) {
      var Transfer = (adminMenus, initData) => {
        if (adminMenus != null && adminMenus.length > 0) {
          adminMenus.forEach(element => {
            if (element.menuType == "2") {
              let data = {
                id: element.id,
                name: element.menuName,
                icon: element.menuIcon,
                path: element.menuPath,
                route: element.menuRoute,
                template: element.menuTemplate,
              }
              initData.push(data)
            }
            if (element.children != null && element.children.length > 0) {
              Transfer(element.children, initData)
            }
          });
        }
      }

      var initData = []
      let adminMenus = state.adminMenus
      if (adminMenus != null && adminMenus.length > 0) {
        Transfer(adminMenus, initData)
      }
      return initData
    },
    adminPower(state) {
      let adminUserId = state.adminUser.userId
      let adminOrganizationId = state.adminUser.userOrganizationId
      let limitUserId = null
      let limitDepartUserId = null

      let adminRoleId = Math.max(...state.adminRoles)
      if (adminRoleId == 1) {
        limitUserId = state.adminUser.userId
      }
      else if (adminRoleId == 2) {
        limitDepartUserId = state.adminUser.userId
      }
      else if (adminRoleId == 3) {
        // 超级管理员
      }
      else {
        limitUserId = state.adminUser.userId
      }

      return {
        adminUserId,
        adminOrganizationId,
        limitUserId,
        limitDepartUserId
      }
    }
  },
  mutations: {
    SET_ASIDECOLLAPSE(state, payload) {
      let { adminCollapse } = payload
      state.adminCollapse = adminCollapse
    },
    SET_ADMINUSER(state, payload) {
      let { accessToken, expiredTime, userId, userOrganizationId, userType, userAccount, userName } = payload
      localStorage.setItem('accessToken', accessToken)
      localStorage.setItem('expiredTime', expiredTime)
      localStorage.setItem('adminId', userId)
      localStorage.setItem('adminOrganizationId', userOrganizationId)
      localStorage.setItem('adminType', userType)
      localStorage.setItem('adminAccount', userAccount)
      localStorage.setItem('adminName', userName)
      state.adminUser = { accessToken, expiredTime, userId, userOrganizationId, userType, userAccount, userName }
    },
    SET_ADMINPOWER(state, payload) {
      let { adminMenus, adminRoles, adminOrganizations } = payload
      state.adminMenus = adminMenus
      state.adminRoles = adminRoles
      state.adminOrganizations = adminOrganizations
    }
  },
  actions: {
    adminMenus(context, payload) {
      let { userId, userType } = context.rootState.adminUser
      return new Promise(async (resolve, reject) => {
        let adminMenus = null
        if (userType == "9") {
          adminMenus = setting.router
        } else {
          adminMenus = await context.dispatch('systemmenu/SystemMenuGetList', { systemUserId: userId, deleteStatus: 0 }, { root: true })
        }

        // 获取权限信息
        let data = { systemUserId: userId, deleteStatus: 0 }
        let roles = await context.dispatch('systemrole/SystemRoleGetList', data, { root: true })
        let adminRoles = roles.map(x => x.roleLevel);
        let organizations = await context.dispatch('systemorganization/SystemOrganizationGetList', { ...data, isTreeData: false }, { root: true })
        let adminOrganizations = organizations.map(x => x.id);
        // 持久化缓存
        context.commit('SET_ADMINPOWER', { adminMenus, adminRoles, adminOrganizations }, { root: true })
        resolve("success")
      })
    },
    adminLeave(context, payload) {
      let adminUser = { accessToken: '', expiredTime: '', userId: '', userOrganizationId: '', userType: '', userAccount: '', userName: '' }
      let adminMenus = []
      let adminRoles = []
      let adminOrganizations = []
      return new Promise((resolve, reject) => {
        context.commit('SET_ADMINPOWER', { adminMenus, adminRoles, adminOrganizations }, { root: true })

        localStorage.removeItem('accessToken')
        localStorage.removeItem('expiredTime')
        context.commit('SET_ADMINUSER', adminUser, { root: true })
        resolve("success")
      })
    }
  },
  modules
})
